import React from 'react'
import { Feed, Divider, Image } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import momentDate from '../../../../../../helpers/momentDate'
import MomentTime from '../../../../../common/MomentTime'
import ImageAvater from '../../../../../drive/Components/ImageAvater';
var moment = require('moment');

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name)
    }
})


class InitiativeLogCard extends React.Component {



    render() {

        let ideaHeadPartComment = this.props.item.comment && this.props.item.comment.substring(
            0,
            this.props.item.comment.indexOf("Note:")
        )
        let ideaNotePartComment = this.props.item.comment && this.props.item.comment.substring(
            this.props.item.comment.indexOf("Note:") + 5
        )
        let initiativeComment = this.props.item.comment && this.props.item.comment.replace(/<\/?[^>]+>/ig, " ")

        let isExternamRef = this.props.selectedDataById && this.props.selectedDataById.externalRefId &&
            this.props.item && this.props.item.comment && this.props.item.comment.includes("Initiative started")

        return (
            <div>
                {this.props.item &&
                    this.props.item.comment ? <Feed className={`issueMessage  `} >
                    <Feed.Event className="pad_5">
                        <ImageAvater user={this.props.item && this.props.item.accountUserId} />
                        <Feed.Content>
                            <Feed.Summary >
                                <div className="float-left" style={{ padding: "3px 0" }}>
                                    {this.props.item && this.props.item.accountUserId.firstName + ' ' + this.props.item.accountUserId.lastName}
                                </div>
                                <div className="float-right">
                                    <span >{momentDate(this.props.item.commentDate)}</span> <br />
                                    <span className="float-right" >
                                        <MomentTime date={this.props.item.commentDate} />
                                    </span>
                                </div>
                            </Feed.Summary>
                        </Feed.Content>
                    </Feed.Event>
                    <Divider className="mar_lr_3" />
                    <div className="pad_5">
                        {this.props.item.comment.includes('Note:') ?
                            <React.Fragment>
                                <div dangerouslySetInnerHTML={{ __html: ideaHeadPartComment }} />
                                <div dangerouslySetInnerHTML={{ __html: "Note : " + ideaNotePartComment }} />
                            </React.Fragment> :
                            <div dangerouslySetInnerHTML={{ __html: initiativeComment }} />
                        }
                    </div>
                </Feed> : null}
            </div>

        )
    }
}

export default InitiativeLogCard